import { MutationButton } from "@Light/components/page/MutationButton";
import { useScaffold } from "@Light/scaffold";
import { useLight } from "@Light/services/light";
import { useLightSandbox } from "@Light/services/lightSandbox";
import { useMutation } from "@Light/utils/mutation";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHeaderBackNavigate, useHeaderTitle } from "../page/header/context";

export type SandboxProps = {};

export const Sandbox: React.FC<SandboxProps> = ({}) => {
  const scaffold = useScaffold();
  const {
    useSeedDemoDataMutation,
    useDeleteDemoDataMutation,
    useDeleteEnrollmentMutation,
  } = useLightSandbox();
  const light = useLight();
  const dispatch = useDispatch();

  useHeaderTitle("Sandbox **DEMO ONLY**");
  useHeaderBackNavigate("/");

  const seedDemoData = useMutation(useSeedDemoDataMutation);
  const deleteDemoData = useMutation(useDeleteDemoDataMutation);
  const deleteEnrollment = useMutation(useDeleteEnrollmentMutation);

  useEffect(() => {
    if (
      !seedDemoData.isSuccess &&
      !deleteDemoData.isSuccess &&
      !deleteEnrollment.isSuccess
    ) {
      return;
    }
    // Tell redux to invalidate our account data as all of these mutations can
    dispatch(light.util.invalidateTags(["Account", "BillingInvoices"]));
  }, [
    seedDemoData.isSuccess,
    deleteDemoData.isSuccess,
    deleteEnrollment.isSuccess,
    light,
    dispatch,
  ]);

  const PageBody = scaffold.page.pageBody;
  return (
    <PageBody>
      <div className="pt-8 flex flex-col gap-4">
        <MutationButton
          mutation={seedDemoData}
          mutateButtonText="Seed Demo Data"
          mutate={seedDemoData.mutate}
          errorMessage="Failed seeding demo data."
          buttonStyle="error"
        />
        <MutationButton
          mutation={deleteDemoData}
          mutateButtonText="Delete Demo Data"
          mutate={deleteDemoData.mutate}
          errorMessage="Failed deleting demo data."
          buttonStyle="error"
        />
        <MutationButton
          mutation={deleteEnrollment}
          mutateButtonText="Delete Enrollment"
          mutate={deleteEnrollment.mutate}
          errorMessage="Failed deleting enrollment."
          buttonStyle="error"
        />
      </div>
    </PageBody>
  );
};
